export const MAX_DAYS_COUNT = 7;
